import React from "react";

const NoLayout: React.FC<{children: React.ReactNode}> = ({ children }) => {

  return(
    <div className="no-layout">
      <div className="content">{children}</div>
    </div>
  )
}

export default NoLayout